import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { PageType, TimeFilter } from 'src/app/models/enums';
import { FilterComponent } from '../../filter/filter.component';


@Component({
  selector: 'app-filter-mobile',
  templateUrl: './filter-mobile.component.html',
  styleUrls: ['./filter-mobile.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class FilterMobileComponent extends FilterComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    if (this.pageType === PageType.Live) {
      setTimeout(() => {
        this.timeFilterValueChange(TimeFilter.Live, PageType.Live);
      });
    }
  }

  public selectResultsTimeFilter(filterValue: TimeFilter) {
    if (this.pageType !== PageType.Results || this.timeFilterValue !== +filterValue) {
      this.timeFilterValueChange(filterValue, PageType.Results);
    }
  }

}
